import * as a from 'actions/googleFonts';

const initial = {
  data: [],
  error: null,
};

const fonts = (state = initial, action = null) => {
  switch (action.type) {
    case a.SET_GOOGLE_FONTS:
      return {
        ...state,
        data: action.fonts,
        error: null,
      };
    default:
      return state;
  }
};

export default fonts;
